import { use, useActionState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { sendVerificationCode } from "./actions/login";
import Label from "../../components/label";
import Input from "../../components/input";
import { Button } from "../../components/button";
import {
  AtSymbolIcon,
  KeyIcon,
  ExclamationCircleIcon,
  ArrowRightIcon,
  PhoneIcon,
} from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Toggle from "../../components/toggle";
import FormError from "../../components/form-error";
import Fonts from "../../core/fonts";
import { UserRole } from "../../enums";
import UsersService from "../../services/UserService";
import Select from "../../components/select";
import Spinner from "../../components/spinner";
const contries = require("../../utils/countries.json");

export default function LoginPage() {
  const navigate = useNavigate();
  const auth = useAuth();
  const api = new UsersService();
  const [searchParams] = useSearchParams();
  const callbackUrl = searchParams.get("callbackUrl") || "/";
  const [state, formAction, isPending] = useActionState(sendVerificationCode, {
    success: false,
    message: null,
    defaultValues: {
      phone: "",
      country: "",
      rememberMe: false,
    },
    errors: {},
  });

  useEffect(() => {
    return () => auth.loaded(true);
  }, []);

  useEffect(() => {
    if (state?.success) {
      navigate("/auth/verify-phone?verificationId="+state.data?.verificationId+"&phone="+ state.defaultValues?.phone+"&rememberMe="+state.defaultValues?.rememberMe);  
    }
  }, [state, callbackUrl]);

 
  return (
    <div className="flex items-center justify-center flex-1">
      <form
        className="space-y-3 w-full max-w-md"
        action={formAction} 
      >
        <div className="flex-1 rounded-lg bg-gray-50 px-6 pb-4 pt-8">
          <h1 className={`${Fonts.lusitanaRegular} mb-3 text-2xl`}>
            Please log in to continue.
          </h1>
          <div className="w-full text-left">
            <div className="mt-4">
              <Label                
                htmlFor="country"
              >
                Country
              </Label>
              <Select
                id="country"
                name="country"
                aria-describedby="country-error"
                items={contries.map((c: any) => {
                  return {
                    id: c.phone_code,
                    name: c.name + " (" + c.phone_code + ")",
                    image: c.flag_url,
                  };
                })}
                defaultValue={"+44"}
                required
                showImages={true}
              ></Select>
            </div>
            <div className="mt-4">
              <Label  htmlFor="phone">
                Your Phone Number
              </Label>
              <Input
                id="phone"
                name="phone"
                type="number"
                placeholder="Enter your phone number"
                required
                Icon={PhoneIcon}
                aria-describedby="phone-error"
                defaultValue={state && state.defaultValues?.phone}
              />
              <FormError
                id="phone-error"
                message={state && state.errors?.phone}
              />
            </div>

            <div className="mb-4 mt-4">
              <Label htmlFor="isActive">Remeber Me</Label>
              <Toggle
                id="rememberMe"
                name="rememberMe"
                aria-describedby="rememberMe-error"
              />
            </div>
          </div>
          <input type="hidden" name="callbackUrl" value={callbackUrl} />
          <Button className="mt-4 w-full" aria-disabled={isPending}>
            Log in 
            {isPending? <div className="ml-auto"><Spinner visible size="small"  /></div> : <ArrowRightIcon className="ml-auto h-5 w-5 text-gray-50" />}
          </Button>
          <div className="flex h-8 items-end space-x-1">
            {state && !state.success && state.message && (
              <>
                <ExclamationCircleIcon className="h-5 w-5 text-red-500" />
                <p className="text-sm text-red-500">{state.message.description}</p>
              </>
            )}
          </div>
          <div className="mt-1 flex w-full items-center justify-around text-purple-500">
            
            <Link to={"/auth/register"}>
              <span>Register</span>
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
}
